import * as Scrivito from "scrivito";
import imageWidgetIcon from "../../assets/images/image_widget.svg";
import YouTubeWidget from "../YouTubeWidget/YouTubeWidgetClass";

Scrivito.provideEditingConfig("IntroSectionWidget", {
  hideInSelectionDialogs: true,
  title: "Intro Section Course Page Widget",
  thumbnail: imageWidgetIcon,
  attributes: {
    image: {
      title: "Image",
      description: "Select image",
    },
    ytVideo: {
      title: "YouTube Video",
    },
    desc: {
      title: "Course Description",
      description:
        "Provide description of the course. Use CSS 'course-short-title' class to change text color to orange e.g. <span class='course-short-title'>Some Course Title...</span> ",
    },
    linkButton: {
      title: "Link Button",
      description:
        "If title is not provided, the obj's title or the external URl is shown. ",
    },
  },
  properties: ["image", "ytVideo", "desc", "linkButton"],
  initialContent: {
    ytVideo: [new YouTubeWidget()],
  },
});
